import { render, staticRenderFns } from "./waterfall-board-activities.vue?vue&type=template&id=6f4d62ee&"
import script from "./waterfall-board-activities.vue?vue&type=script&lang=js&"
export * from "./waterfall-board-activities.vue?vue&type=script&lang=js&"
import style0 from "./waterfall-board-activities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports